export default function ITCoreProceduresController(
  $q,

  editITCoreProceduresDialog,
  ssDialogService
) {
  const vm = this;

  vm.handleEditITCoreProceduresClick = _handleEditITCoreProceduresClick;

  _activate();

  /** **********************************************
   * Event Handlers
   */

  function _handleEditITCoreProceduresClick($event) {
    ssDialogService.dialogs.bcp.editITCoreProceduresDialog = ssDialogService.alert(
      editITCoreProceduresDialog.getOptions($event, {
        assessmentItCoreProcedures: vm.assessmentItCoreProcedures,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editITCoreProceduresDialog);
  }

  /** **********************************************
   * Private Functions
   */

  function _activate() {
  }
}

ITCoreProceduresController.$inject = [
  '$q',

  'editITCoreProceduresDialog',
  'ssDialogService',
];
